import { BubbleChatOutcomeIcon, UserSwitchIcon } from '@hugeicons/core-free-icons';
import cn from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { IconComponent } from 'components/Icon/IconComponent';
import StatusPill from 'components/Pills/StatusPills';

import styles from './RefereeCard.module.scss';

export const RefereeCard = ({
  title = 'Referee',
  name,
  subtitle,
  referee,
  referees = [],
  selected,
  disabled,
  combined = false,
  onClick = () => {},
}) => {
  return (
    <div
      className={cn(styles.root, 'u-border', {
        [styles.rootSelected]: selected,
        [styles.rootDisabled]: disabled,
      })}
      onClick={() => onClick(referee)}>
      <div className="d-flex flex-column u-width-100">
        {referee.replaced_by && (
          <div
            className={cn(
              styles.badgeSection,
              styles.replacedBy,
              'd-flex align-items-center justify-content-center',
            )}>
            <IconComponent icon={UserSwitchIcon} noBackground size="small" type="neutral-light" />
            <span className="u-font-size-small u-font-weight-400">
              {(() => {
                const replacedReferee = referees?.find(r => r.id === referee.replaced_by);
                return replacedReferee?.name?.trim()
                  ? `Replaced by ${replacedReferee.name}`
                  : 'Awaiting replacement';
              })()}
            </span>
          </div>
        )}
        {referee.answered_on_behalf_user_id && !combined && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Answered on behalf by {referee.answered_on_behalf_user}</Tooltip>}>
            <div
              className={cn(
                styles.badgeSection,
                styles.answeredOnBehalf,
                'd-flex align-items-center justify-content-center',
              )}>
              <IconComponent
                icon={BubbleChatOutcomeIcon}
                noBackground
                size="small"
                type="neutral-light"
              />
              <span className="u-font-size-small u-font-weight-400">
                Answered on behalf of Candidate
              </span>
            </div>
          </OverlayTrigger>
        )}
        <div
          className={cn(
            styles.details,
            'd-flex justify-content-between u-width-100 align-items-start u-padding',
          )}>
          <div className="d-flex flex-column u-gap">
            <div className="d-flex flex-column">
              <div className="u-font-size-x-small u-font-weight-400">{title}</div>
              <div className="u-font-size-x-large u-font-weight-500 primary-text">{name}</div>
            </div>
            {subtitle && (
              <div className="u-font-size-x-small u-font-weight-400 secondary-text">{subtitle}</div>
            )}
          </div>
          {!combined && (
            <StatusPill
              status={referee.status === 'candidate' ? 'pending' : referee.status}
              text={!disabled ? referee.status : ''}
              className="u-uppercase"
              small
            />
          )}
        </div>
      </div>
    </div>
  );
};
